export const last = (arr) => (arr === null || arr === void 0 ? void 0 : arr.length) > 0 ? arr[(arr === null || arr === void 0 ? void 0 : arr.length) - 1] : undefined;
export const secondToLast = (arr) => (arr === null || arr === void 0 ? void 0 : arr.length) > 2 ? arr[arr.length - 2] : undefined;
export const createArrayOfNumbers = (elementsNumber) => Array.from(Array(elementsNumber).keys());
export const enumToArray = (inputEnum) => {
    const values = Object.values(inputEnum);
    return values.slice(0, values.length / 2);
};
export const filterUnique = (value, index, self) => self.indexOf(value) === index;
export const areArraysSame = (first, second) => JSON.stringify(first) === JSON.stringify(second);
export const deepCloneByJson = (arrayToClone) => JSON.parse(JSON.stringify(arrayToClone));
//# sourceMappingURL=index.js.map